import React, { useEffect } from 'react';

import { styled } from '@mui/material/styles';
import { Box, Divider, Grid } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { SlidesContainer } from 'common/components/socialSlide';
import { getIsGuest } from 'common/utils/session';

import divider from 'resources/diamondDivider.svg';
import fondoLogin1 from 'resources/fondoLogin1.png';
import logotipo from 'resources/logotipo.svg';
import imgSunpay from 'resources/slides/login/img_sunpay.png';

import { loginUser } from './actions';
import LoginForm from './components/LoginForm';
import * as selectors from './selectors';

const StyledGrid = styled(Grid)`
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background: #fff url(${fondoLogin1});
`;

const StyledSlideTitle = styled('h1')`
    font-size: 26px !important;
    line-height: 32px;
    margin-top: auto;
    text-align: left;
`;

const StyledSlideImage = styled('img')`
    cursor: pointer;
    display: block;
    margin: auto;
    width: 100%;
`;

const StyledSlideLabel = styled('span')`
    color: #ff9a00;
`;

const StyledSlideLink = styled('a')`
    color: #ff9a00 !important;
    cursor: pointer;
    font-size: 16px !important;
    font-weight: normal !important;
    line-height: 26px !important;

    &:hover {
        color: #ff9a00 !important;
        text-decoration: none;
    }
`;

const ImageContentSlide = ({
    description,
    featuredDescription,
    featuredTitle,
    imgUrl,
    link,
    title,
}) => (
    <>
        <StyledSlideTitle>
            {title}
            <StyledSlideLabel>{featuredTitle}</StyledSlideLabel>
        </StyledSlideTitle>

        <p>
            {description}&nbsp;
            <StyledSlideLink href={link} target="_blank">
                {featuredDescription}
                <StyledSlideImage src={imgUrl} />
            </StyledSlideLink>
        </p>
    </>
);

ImageContentSlide.propTypes = {
    description: PropTypes.string,
    featuredDescription: PropTypes.string,
    featuredTitle: PropTypes.string,
    imgUrl: PropTypes.string,
    link: PropTypes.string,
    title: PropTypes.string,
};

const Container = ({
    errors,
    initialValues,
    isLoadingSession,
    loginUser,
    redirect,
}) => {
    useEffect(() => {
        if (!getIsGuest()) redirect('/');
    }, []);

    const handleSubmit = (values) => loginUser(values);

    const slides = [
        {
            content: (
                <ImageContentSlide
                    description=""
                    featuredDescription=""
                    featuredTitle=""
                    imgUrl={imgSunpay}
                    link=""
                    title=""
                />
            ),
        },
    ];

    return (
        <Grid container spacing={0} sx={{ alignItems: 'center', flexGrow: 1 }}>
            <StyledGrid
                size={{ md: 9, xs: 18 }}
                sx={{ alignItems: 'center', display: 'flex', height: '100%' }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'center',
                        margin: '0 auto',
                        maxWidth: '670px',
                        px: { md: 3, xs: 2 },
                        width: '100%',
                    }}
                >
                    <Box sx={{ textAlign: 'center' }}>
                        <img alt="Sunpay" src={logotipo} width="265" />
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <LoginForm
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        isLoadingSession={isLoadingSession}
                        errors={errors}
                    />
                </Box>
            </StyledGrid>

            <Grid
                size={{ md: 9 }}
                sx={{
                    alignItems: 'center',
                    backgroundColor: '#f6f8fa',
                    display: { md: 'flex', xs: 'none' },
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center',
                    p: 4,
                }}
            >
                <Box sx={{ my: 2, textAlign: 'center' }}>
                    <img alt="divider" src={divider} />
                </Box>

                <SlidesContainer slides={slides} />
            </Grid>
        </Grid>
    );
};

Container.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    loginUser: PropTypes.func,
    redirect: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getErrorsLogin,
    initialValues: selectors.getInitialValues,
    isLoadingSession: selectors.getIsLoadingSession,
    validPassword: selectors.getValidPassword,
});

const mapDispatchToProps = (dispatch) => ({
    loginUser: (data) => dispatch(loginUser(data)),
    redirect: (link) => dispatch(push(link)),
});

Container.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    loginUser: PropTypes.func,
    redirect: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
